import { render } from "./Security_Deposits.vue?vue&type=template&id=580f97cd"
import script from "./Security_Deposits.vue?vue&type=script&lang=js"
export * from "./Security_Deposits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__